// import Cookies from 'js-cookie'
import { getLanguage } from '@/lang/index'
import getBrand from '@/utils/brand'

const state = {
  device: 'desktop',
  language: getLanguage(),
  // brand: Cookies.get('brand') || getBrand(),
  brand: localStorage.getItem('brand') || getBrand(),
  title: ''
}

const mutations = {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    // Cookies.set('etower-ubi-spww-language', language)
    localStorage.setItem('etower-ubi-spww-language', language)
  },
  SET_BRAND: (state, brand) => {
    state.brand = brand
  }
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setBrand({ commit }, host) {
    const brand = getBrand(host)
    // Cookies.set('brand', brand)
    localStorage.setItem('brand', brand)
    commit('SET_BRAND', brand)
  },
  setTitle({ commit }, title) {
    document.title = title ? `${title} - ${state.brand}` : state.brand
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
